module.exports = __webpack_public_path__ + "media/images/av_hero_background-76991f038b12ff33b9d0940483cf075d.png";